import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sourcesList", "trixEditor"]

  static values = { recipient: String }

  connect() {
    App.popover(".trix-toolbar-button[data-bs-toggle='popover']")
  }

  send(e) {
    if ($(e.target).hasClass("disabled")) {
      console.info("Your email is being sent...")
      return
    }

    $(e.target).addClass("disabled")

    fetch("/messages", {
      method: "POST",
      credentials: "same-origin",
      headers: new Headers({
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content")
      }),
      body: JSON.stringify({
        message: {
          to: this.recipientValue,
          subject: $("input#subject-field").val(),
          body: $("input#body-field").val(),
          add_unsubscribe_link: $("input#message_add_unsubscribe_link").is(":checked"),
          email_account_id: $("#email-account-field").val(),
          tracked: $("input#tracked-field").is(":checked"),
        }
      })
    }).then(response => response.json())
      .then(object => {
        $(e.target).removeClass("disabled")

        if (object.error != undefined) {
          let message = ""

          if (!object.rate_limit) {
            message = "Error: "
          }

          message += object.error

          $("#compose-modal .error-message").show().html(`<span>${message}</span>`)
          return
        }

        App.modal("#compose-modal", "hide")
        App.displayFlash("success", `Your email to ${this.recipientValue} is on its way.`)
        App.analytics.ga_track("Email", "Send")

      }).catch(error => {
        $(e.target).removeClass("disabled")

        $("#compose-modal .error-message").show().html("Your email couldn't be created. Please retry and contact us if the problem persists.")

        console.error(`Failed to create the email: ${error}`)
      })
  }

  templateSelected() {
    var template = $("select#template-field").find(":selected")
    $("#subject-field").val(template.data("subject"))
    this.trixEditorTarget.editor.loadHTML(template.data("body"))
  }

  toggleSources(e) {
    $(e.target).find(".far").toggleClass("fa-angle-up").toggleClass("fa-angle-down")
    $(this.sourcesListTarget).slideToggle(200)
  }
}
